// AdvertiserContext.js

import { createContext, useState, useEffect, useContext, useRef } from 'react'
import { useLocalStorage } from '../hooks/useLocalStorage'
import { SharedContext } from './SharedContext'
import { fetchContextData } from '../services/submissions'
import Cookies from 'universal-cookie'
import { useRouter } from 'next/router'
import { Media } from '../commonComponents/Media'
import classNames from 'classnames'

import dynamic from 'next/dynamic'
import { FORM_KEYS } from '../constants/hire/advertiserForm'
import {
  exitDashboard,
  isAndroid,
  isModernWebView,
  registerJobsBackGesture,
  registerNewsBackGesture,
  showRoleSelectionScreen,
  getAppType
} from '@/android/bridge'
import { useRouterHook } from '@/hooks/useRouterHook'
import { tryCloseTop } from '@/utils/backStack'
import { isRazorpayOpen } from '@/utils/razorpay'
import { logEvent } from '@/analytics/eventLogger'
import { EVENTS } from '@/analytics/constants'
import ExitBottomSheet from '../components/sheets/ExitBottomSheet'
// Default exports
const AdvertiserBackModal = dynamic(() => import('../commonComponents/AdvertiserBackModal'), {
  ssr: false
})

// Named exports
const SkeletonsHandler = dynamic(
  () => import('../components/SkeletonsHandler').then((mod) => mod.SkeletonsHandler),
  {
    ssr: false
  }
)

const Toast = dynamic(() => import('../components/Toast').then((mod) => mod.Toast), {
  ssr: false
})

const AdvertiserToast = dynamic(
  () => import('../advertiserComponents/AdvertiserToast').then((mod) => mod.AdvertiserToast),
  {
    ssr: false
  }
)

const HamburgerMenu = dynamic(
  () => import('@/components/HamburgerMenu').then((mod) => mod.HamburgerMenu),
  {
    ssr: false
  }
)

export const AdvertiserContext = createContext()

export const AdvertiserContextProvider = ({ children }) => {
  // ----------- U STATES (useState) -----------
  const [isAdvertiserMenuClicked, setAdvertiserMenuClicked] = useState(false)
  const [showAdvertiserToast, setShowAdvertiserToast] = useState({ isVisible: false })
  const [isPlanSelected, setIsPlanSelected] = useState(true)
  const [isDistrictSelected, setIsDistrictSelected] = useState(false)
  const [totalAmount, setTotalAmount] = useState('')
  const [orderId, setOrderId] = useState('')
  const [languageFromAndroid, setLanguagefromAndriod] = useState('en')
  const [editJobStatus, setEditJobStatus] = useState('')
  const [submissionId, setSubmissionId] = useState(null)
  const [editJobSubmissionId, setEditJobSubmissionId] = useState()
  const [jobDistrictList, setJobDistrictList] = useState([])
  const [isResponsesClicked, setResponsesClicked] = useState(false)
  const [enterpriserFlow, setEnterpriserFlow] = useState(false)
  const [isEditReportClicked, setEditReportclicked] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [advertiserBackModalOpen, setAdvertiserBackModalOpen] = useState({
    isOpen: false,
    data: {},
    id: '',
    buttonTitles: ['', ''],
    onClickActions: [() => {}, () => {}],
    title: '',
    caption: ''
  })
  const [isComponentOpen, setComponentOpen] = useState(false)
  const [isUploadModalOpen, setUploadModalOpen] = useState(true)
  const [backClicked, setBackClicked] = useState(false)
  const [exitSheetOpen, setExitSheetOpen] = useState(false)

  // ----------- L STATES (useLocalStorage) -----------
  const [formData, setFormData] = useLocalStorage('formData', {})
  const [tempFormData, setTempFormData] = useLocalStorage('tempFormData', {
    data: {},
    isPresent: false,
    title: 'Edit your job post'
  })
  const [postJobPresentStep, setpostJobPresentStep] = useLocalStorage('postJobPresentStep', 1)
  const [formContext, setFormContext] = useLocalStorage('formContext', {})

  const [selectedCandidateIndex, setSelectedCandidateIndex] = useLocalStorage(
    'selectedCandidateIndex',
    0
  )
  const [advertiserCandidateTabIndex, setAdvertiserCandidateTabIndex] = useLocalStorage(
    'advertiserCandidateTabIndex',
    0
  )
  const [queryParams, setQueryParams] = useLocalStorage('queryParams', '')
  const [isReviewPageOpended, setReviewPageOpended] = useLocalStorage('isReviewPageOpended', false)
  const [isSuccess, setIsSuccess] = useLocalStorage('isSuccess', 'default')
  const [isPaymentSuccess, setPaymentSuccesss] = useLocalStorage('isPaymentSuccess', false)
  const [submittedJobId, setSubmittedJobId] = useLocalStorage('submittedJobId', null)
  const [packagesPresent, setPackagesPresent] = useLocalStorage('packagesPresent', true)
  const [skills, setSkills] = useLocalStorage('skills', [])
  const [selectedData, setSelectedData] = useLocalStorage('selectedData', {})
  const [isPayMentFailed, setPayMentFailed] = useLocalStorage('isPayMentFailed', {
    isfailed: false,
    selectedPlan: null,
    selectedUpsell: null
  })
  const [enterpriseLoginDetails, setEnterpriseLoginDetails] = useLocalStorage(
    'enterpriseLoginDetails',
    {}
  )
  const [enterprisePlanOptions, setEnterprisePlanOptions] = useLocalStorage(
    'enterprisePlanOptions',
    {}
  )
  const [showEdit, setShowEdit] = useLocalStorage('showEdit', true)
  const [variant, setVariant] = useLocalStorage('variant', null)

  const [advertiserProfileDetails, setAdvertiserProfileDetails] = useLocalStorage(
    'advertiserProfileDetails',
    {}
  )

  const {
    loginDetails,
    windowSize,
    setScrollBar,
    isMenuClicked,
    setMenuClicked,
    showToast,
    skeletonloader
  } = useContext(SharedContext)

  const cookie = new Cookies()
  const router = useRouter()
  const { navigateToPagesInAdvertiser } = useRouterHook()

  //control navigation on multiple button click
  const isNavigatingRef = useRef(false)

  const guardNavigation = async (action) => {
    try {
      await action()
    } finally {
      isNavigatingRef.current = false
    }
  }


  const getUserVariant = async () => {
    if (isAndroid()) {
      setVariant('pay_later')
      return
    }
    if (enterpriseLoginDetails?.advertiserId || windowSize > 640) {
      setVariant('pay_now')
      return
    }
    try {
      setVariant('pay_later')
    } catch (error) {
      setVariant('pay_later')
      console.error('something went wrong in getting the variant')
    }
  }

  const advertiserBackModalClose = () => {
    setAdvertiserBackModalOpen({
      isOpen: false,
      data: {},
      id: '',
      buttonTitles: ['', ''],
      onClickActions: [() => {}, () => {}],
      title: '',
      caption: ''
    })
  }

  const popAdvertiserPage = () => {
    closeAdvertiserComponents()
    // If you had an advertiser pageTitles, you can do it here
    return false
  }

  const closeAdvertiserComponents = () => {
    setAdvertiserMenuClicked(false)
    setScrollBar(true)
    advertiserBackModalClose()
  }

  const leaveDashboard = () => {
    logEvent(EVENTS.TAP_LEAVE_PAGE, { label: 'advertiser_dashboard' });
    setExitSheetOpen(false)
    const type = getAppType()
    if (type === 'jobs_wbv') {
      showRoleSelectionScreen()
    } else {
      exitDashboard()
    }
  }

  const backGestureFactory = (exitFn) => {
    /** Helpers that return `true` when they handled the gesture */
    const closeOverlays = () => {
      if (exitSheetOpen) {
        setExitSheetOpen(false)
        exitFn()
        return true
      }
      if (tryCloseTop()) return true
      if (isMenuClicked) {
        setMenuClicked(false)
        return true
      }
      if (isRazorpayOpen()) {
        router.back()
        return true
      }
      return false
    }

    const handlePostJobFlow = () => {
      if (router.pathname !== '/advertiserPostJob') return false

      const canPop =
        postJobPresentStep === 1 ||
        (postJobPresentStep === 4 && !(submissionId || formData?.submissionId))

      if (canPop) {
        navigateToPagesInAdvertiser({ pathName: 'advertiserDashboardPage', as: 'dashboard' })
      } else {
        setpostJobPresentStep((s) => (s > 1 ? s - 1 : s))
      }
      return true
    }

    const handleDashboard = () => {
      if (router.pathname !== '/advertiserDashboardPage') return false

      /* 1st press → open sheet | 2nd press while sheet open → exit */
      if (!exitSheetOpen) setExitSheetOpen(true)

      return true
    }

  /** Payment-status page → jump straight to Dashboard on modern SDK */
  const handlePaymentStatus = () => {
    if (router.pathname !== '/advertiserPaymentStatus') return false;

    if (isModernWebView() && Android?.goToDashboard) Android.goToDashboard();
    return true;   // always consume the back-gesture on this route
  };

    return () => {
      if (closeOverlays()) return
      if (handlePostJobFlow()) return
      if (handleDashboard()) return
      if (handlePaymentStatus()) return
      /* Fallback */
      router.back()
    }
  }

  registerNewsBackGesture(backGestureFactory(exitDashboard))
  registerJobsBackGesture(backGestureFactory(showRoleSelectionScreen))

  // ----------- USE EFFECT -----------
  useEffect(() => {
    if (!exitSheetOpen) return
    logEvent(EVENTS.TAP_BACK, { label: 'advertiser_dashboard' });
  }, [exitSheetOpen])

  useEffect(() => {
    if (loginDetails?.isLogIn || isAndroid()) {
      getUserVariant()
    }
  }, [loginDetails?.isLogIn])

  useEffect(() => {
    if (formContext?.job_category_list) {
      const category = formContext?.job_category_list.find(
        (item) => item?.id === formData?.job_category
      )
      setSelectedCategory(category)
    }
  }, [formContext?.job_category_list, formData?.job_category])

  useEffect(() => {
    cookie.set('selectedCandidateIndex', selectedCandidateIndex, { path: '/' })
  }, [selectedCandidateIndex])

  useEffect(() => {
    cookie.set('advertiserCandidateTabIndex', advertiserCandidateTabIndex, { path: '/' })
  }, [advertiserCandidateTabIndex])

  useEffect(() => {
    if (loginDetails?.isLogIn) {
      fetchContextData({
        cookie,
        setFormContext,
        isEnterprise: !!enterpriseLoginDetails?.advertiserId
      })
    }
  }, [loginDetails?.isLogIn])

  useEffect(() => {
    closeAdvertiserComponents()
  }, [])

  useEffect(() => {
    if (isAdvertiserMenuClicked || isMenuClicked) {
      setComponentOpen(true)
    } else if (isComponentOpen) {
      setComponentOpen(false)
    }
  }, [isAdvertiserMenuClicked, isMenuClicked])

  useEffect(() => {
    if (isMenuClicked) {
      logEvent(EVENTS.TAP_MENU, { label: 'advertiser_dashboard' })
    }
  }, [isMenuClicked])

  useEffect(() => {
    const handleStart = async (url) => {
      let prvData = JSON.parse(localStorage.getItem('historyStack') || '[]') || []
      if (prvData?.data?.[prvData?.data?.length - 2]?.as === url) {
        // if route is advertiser route => do your logic
        if (router.pathname === '/advertiserPostJob') {
          if (
            !(
              postJobPresentStep === 1 ||
              (postJobPresentStep === 4 && !(submissionId || formData?.submissionId))
            )
          )
            history.forward()
          setpostJobPresentStep((prev) => (prev !== 1 ? prev - 1 : prev))
        }
        // else if (router.pathname === '/advertiserJobReview') {
        //   const previousPath = prvData?.data?.at(-2)?.pathname
        //   if (previousPath === '/advertiserDashboardPage' && tempFormData?.isPresent) {
        //     setTimeout(
        //       () =>
        //         setTempFormData((prevTemp) => {
        //           setFormData(prevTemp?.data)
        //           return { data: {}, isPresent: false, title: 'Edit your job post' }
        //         }),
        //       2500
        //     )
        //   }
        // }
      }
    }

    const popState = async () => {
      popAdvertiserPage()
    }

    router.events.on('routeChangeStart', handleStart)
    addEventListener('popstate', popState)

    return () => {
      router.events.off('routeChangeStart', handleStart)
      removeEventListener('popstate', popState)
    }
  }, [router, isComponentOpen, postJobPresentStep, tempFormData])

  const updateEducationField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [FORM_KEYS?.EDUCATION_DATA]: [
        {
          ...prev[FORM_KEYS?.EDUCATION_DATA]?.[0],
          [field]: value
        }
      ]
    }))
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }))
  }

  return (
    <AdvertiserContext.Provider
      value={{
        // U states
        isAdvertiserMenuClicked,
        setAdvertiserMenuClicked,
        showAdvertiserToast,
        setShowAdvertiserToast,
        isPlanSelected,
        setIsPlanSelected,
        isDistrictSelected,
        setIsDistrictSelected,
        totalAmount,
        setTotalAmount,
        orderId,
        setOrderId,
        languageFromAndroid,
        setLanguagefromAndriod,
        editJobStatus,
        setEditJobStatus,
        editJobSubmissionId,
        setEditJobSubmissionId,
        jobDistrictList,
        setJobDistrictList,
        isResponsesClicked,
        setResponsesClicked,
        enterpriserFlow,
        setEnterpriserFlow,
        isEditReportClicked,
        setEditReportclicked,
        selectedCategory,
        setSelectedCategory,
        advertiserBackModalOpen,
        setAdvertiserBackModalOpen,
        submissionId,
        setSubmissionId,
        isUploadModalOpen,
        setUploadModalOpen,

        // L states
        formData,
        setFormData,
        tempFormData,
        setTempFormData,
        postJobPresentStep,
        setpostJobPresentStep,
        formContext,
        setFormContext,
        selectedCandidateIndex,
        setSelectedCandidateIndex,
        advertiserCandidateTabIndex,
        setAdvertiserCandidateTabIndex,
        queryParams,
        setQueryParams,
        isReviewPageOpended,
        setReviewPageOpended,
        isSuccess,
        setIsSuccess,
        isPaymentSuccess,
        setPaymentSuccesss,
        submittedJobId,
        setSubmittedJobId,
        packagesPresent,
        setPackagesPresent,
        skills,
        setSkills,
        selectedData,
        setSelectedData,
        isPayMentFailed,
        setPayMentFailed,
        enterpriseLoginDetails,
        setEnterpriseLoginDetails,
        enterprisePlanOptions,
        setEnterprisePlanOptions,
        showEdit,
        setShowEdit,
        variant,
        setVariant,
        advertiserProfileDetails,
        setAdvertiserProfileDetails,
        backClicked,
        setBackClicked,
        setExitSheetOpen,
        exitSheetOpen,
        //helpers
        advertiserBackModalClose,
        // updateField,
        updateEducationField,
        //navigation control state and handler
        guardNavigation,
        isNavigatingRef
      }}
    >
      {skeletonloader?.isVisible && <SkeletonsHandler skeletonName={skeletonloader?.pathName} />}
      <Media at="sm">
        {!skeletonloader?.isVisible &&
          (isMenuClicked ? (
            <HamburgerMenu
              {...{
                setMenuClicked,
                isMenuClicked,
                enterpriseLoginDetails,
                setEnterpriseLoginDetails,
                setAdvertiserBackModalOpen,
                setAdvertiserMenuClicked,
                advertiserBackModalClose,
                advertiserProfileDetails,
                setAdvertiserProfileDetails
              }}
            />
          ) : (
            children
          ))}
      </Media>
      <Media greaterThan="sm">
        {(isMenuClicked || isAdvertiserMenuClicked || advertiserBackModalOpen?.isOpen) && (
          <div
            className={classNames('fixed z-50 h-full w-full')}
            onClick={closeAdvertiserComponents}
          />
        )}
        {!skeletonloader?.isVisible && children}
      </Media>
      {showToast?.isVisible && (
        <Toast
          {...{
            toastDetails: showToast?.details
          }}
        />
      )}
      {showAdvertiserToast?.isVisible && (
        <AdvertiserToast
          {...{
            toastDetails: showAdvertiserToast?.details
          }}
        />
      )}
      <ExitBottomSheet
        isOpen={exitSheetOpen}
        onClose={() => setExitSheetOpen(false)}
        onContinue={() => {
          setExitSheetOpen(false);
          logEvent(EVENTS.TAP_CONTINUE_HIRING, { label: 'advertiser_dashboard' });
        }}
        onLeave={leaveDashboard}
      />
      <AdvertiserBackModal />
    </AdvertiserContext.Provider>
  )
}
